import { render, staticRenderFns } from "./Klasse.vue?vue&type=template&id=f4b55c0a&"
import script from "./Klasse.vue?vue&type=script&lang=js&"
export * from "./Klasse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports